import { combineReducers } from "redux";

import damsReducer from "./dam/reducer";
import authReducer from './auth/reducer';
import cameraReducer from './camera/reducer';
import postReducer from './post/reducer';
import riverReducer from "./river/reducer";
import damTypeReducer from "./damType/reducer";
import damStatusReducer from "./damStatus/reducer";
import damScheduleReducer from "./damSchedule/reducer";
import rynanStationReducer from "./station/reducer";

// ==============================|| COMBINE REDUCER ||============================== //

const reducer = combineReducers({
  dam: damsReducer,
  auth: authReducer,
  camera: cameraReducer,
  post: postReducer,
  river: riverReducer,
  damType: damTypeReducer,
  damStatus: damStatusReducer,
  damSchedule: damScheduleReducer,
  rynanStation: rynanStationReducer,
  
});
export default reducer;
